import React from 'react';
import SectionHeader from './SectionHeader';
import { motion } from 'framer-motion';

const experiments = [
  { title: "Generative UI", tag: "Concept", desc: "UI that builds itself based on user intent." },
  { title: "Voice Synth", tag: "Prototype", desc: "Real-time voice cloning for NPCs." },
  { title: "Chaos Monkey AI", tag: "Tool", desc: "Agent that randomly tests UI durability." },
  { title: "Dream Stream", tag: "Visuals", desc: "Infinite video generation loop." },
];

const Lab = () => {
  return (
    <section id="lab" className="py-24 bg-obsidian">
      <div className="container mx-auto px-6">
        <SectionHeader 
          title="Lab Experiments" 
          subtitle="Playground for cutting-edge tests and unfinished ideas." 
          align="center"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {experiments.map((exp, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: idx * 0.05 }}
              viewport={{ once: true }}
              className="p-6 bg-steel/30 border border-dashed border-white/10 hover:border-neon-cyan/50 hover:bg-steel/50 transition-all cursor-pointer rounded-lg relative group overflow-hidden"
            >
              <div className="absolute inset-0 bg-neon-cyan/5 opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="flex justify-between items-start mb-4 relative z-10">
                <span className="text-neon-cyan/70 font-mono text-[10px] uppercase border border-neon-cyan/20 px-2 py-1 rounded">
                  {exp.tag}
                </span>
                <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              </div>
              <h4 className="text-white font-bold font-orbitron mb-2 relative z-10">{exp.title}</h4>
              <p className="text-xs text-gray-400 font-mono relative z-10">{exp.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Lab;